import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { utility } from '../common/utility';

@Injectable({
  providedIn: 'root'
})
export class MessageService {
    baseUrl: string
    constructor(private http: HttpClient) { }

    public GetMessagesBySourceTypeId(sourceTypeId: number, first: number, rows: number, searchText: string): Observable<any> {

        this.baseUrl = environment.apiBase.concat("message/GetMessagesBySourceTypeId?SourceTypeId=" + sourceTypeId + "&&first=" + first + "&&rows=" + rows + "&&searchText=" + searchText);

        return this.http.get<any[]>(this.baseUrl).pipe(catchError(utility.handleError<any[]>('GetMessagesBySourceTypeId', [])));
    }

    public UpdateMessageFavorite(message: any): any {
        this.baseUrl = environment.apiBase.concat("message/UpdateMessageFavorite");
        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        return this.http.post(this.baseUrl, message, { headers: headers }).
            pipe(catchError(utility.handleError<any>('UpdateMessageFavorite', [])));
    }

    public UpdateMessageSetting(userSettings: any): any {
        this.baseUrl = environment.apiBase.concat("message/UpdateMessageSetting");
        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        return this.http.post(this.baseUrl, userSettings, { headers: headers }).
            pipe(catchError(utility.handleError<any>('UpdateMessageSetting', [])));
    }

    public GetUserSetting(): Observable<any> {

        this.baseUrl = environment.apiBase.concat("message/GetUserSetting");

        return this.http.get<any[]>(this.baseUrl).pipe(catchError(utility.handleError<any[]>('GetUserSetting', [])));
    }

    public GetCurrentUser(): Observable<any> {

        this.baseUrl = environment.apiBase.concat("message/GetCurrentUser");

        return this.http.get<any[]>(this.baseUrl).pipe(catchError(utility.handleError<any[]>('GetCurrentUser', [])));
    }

    public addMessage(message: any): any {
        this.baseUrl = environment.apiBase.concat("Message");
        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        return this.http.post(this.baseUrl, message, { headers: headers }).
            pipe(catchError(utility.handleError<any>('addMessage', [])));
    }

    public GetMessageById(id: any): Observable<any> {

        this.baseUrl = environment.apiBase.concat("Message/GetMessageById?Id=" + id);

        return this.http.get<any[]>(this.baseUrl).pipe(catchError(utility.handleError<any[]>('GetNewsMessage', [])));
    }
    public RemoveMessage(id: any): Observable<any> {

        this.baseUrl = environment.apiBase.concat("Message/RemoveMessage?id=" + id);
      
          return this.http.get<any[]>(this.baseUrl).pipe(catchError(utility.handleError<any[]>('RemoveMessage', [])));
      }
}
